import { Injectable } from '@angular/core';
import { propertyTypeEnum, sortOrderEnum } from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class DataSortService {
  sortData(
    dataToSort: any,
    sortField: string,
    fieldType: propertyTypeEnum,
    sortType: sortOrderEnum,
    secondarySortField?: string
  ) {
    let diff;
    dataToSort?.sort((a, b) => {
      if (sortType === sortOrderEnum.descending) {
        const temp = a;
        a = b;
        b = temp;
      }

      switch (fieldType) {
        case propertyTypeEnum.string:
          return a[sortField]
            .toLowerCase()
            .localeCompare(b[sortField].toLowerCase());
        case propertyTypeEnum.number:
          return a[sortField] - b[sortField];
        case propertyTypeEnum.date:
          diff =
            new Date(a[sortField]).getTime() - new Date(b[sortField]).getTime();
          if (diff == 0 && secondarySortField) {
            return b[secondarySortField] - a[secondarySortField];
          } else {
            return diff;
          }
      }
    });
  }
}
